import { AdminPropertyAd } from 'types'
import { propertyMap } from './constants'
import { get, groupBy } from 'lodash'

export function calculateInterest(adCategoryId: number): string {
  const INTEREST_BUY = [1, 2, 3]
  const INTEREST_LOAN = [4, 5, 6]

  const IS_BUY = INTEREST_BUY.includes(adCategoryId)
  const IS_LOAN = INTEREST_LOAN.includes(adCategoryId)
  if (IS_BUY) return 'buy'
  else if (IS_LOAN) return 'loan'
  else return ''
}

export function calculateCategory(adCategoryId: number): string {
  const ESTATE_CATEGORY = [1, 4]
  const COMMERCIAL_CATEGORY = [2, 5]
  const LAND_CATEGORY = [3, 6]

  const IS_ESTATE = ESTATE_CATEGORY.includes(adCategoryId)
  const IS_COMMERCIAL = COMMERCIAL_CATEGORY.includes(adCategoryId)
  const IS_LAND = LAND_CATEGORY.includes(adCategoryId)
  if (IS_ESTATE) return 'estate'
  else if (IS_COMMERCIAL) return 'commercial'
  else if (IS_LAND) return 'land'
  else return ''
}

export function calculateAdCategoryId(
  category: string,
  interest: string
): number {
  let adcategoryId
  switch (interest) {
    case 'buy':
      switch (category) {
        case 'estate':
          adcategoryId = 1
          break
        case 'commercial':
          adcategoryId = 2
          break
        case 'land':
          adcategoryId = 3
          break
      }
      break
    case 'loan':
      switch (category) {
        case 'estate':
          adcategoryId = 4
          break
        case 'commercial':
          adcategoryId = 5
          break
        case 'land':
          adcategoryId = 6
          break
      }
      break
  }
  return adcategoryId
}

export interface ParsedAdminPropertyAd extends AdminPropertyAd {
  parsedData?: any
}

export function parseAdminPropertyAd(
  data: AdminPropertyAd
): ParsedAdminPropertyAd {
  const temp = data as ParsedAdminPropertyAd
  const properties = data?.properties?.[0]?.propertyAttributes
  const grouped = groupBy(properties, 'type.description')
  const transformedProperties = Object.entries(grouped).reduce((acc, group) => {
    let value
    const match = propertyMap.get(group[0])
    if (match) {
      if (!match?.multiple && group[1]?.length === 1 && !match?.map) {
        if (match?.type === 'TEXT') {
          value = get(group[1][0], 'valueText', '')
        } else if (match?.type === 'NUMBER') {
          value = get(group[1][0], 'valueNumber', '')
        }
        if (typeof value === 'number' || (typeof value === 'string' && value)) {
          return { ...acc, [match?.field as string]: value }
        } else return acc
      }
      if (match?.multiple && group[1]?.length > 0) {
        const tempArray: string[] = []
        value = group[1].forEach((property) => {
          const tempValue = get(property, 'valueText', '')
          if (tempValue) tempArray.push(tempValue)
        })

        if (tempArray?.length > 0) {
          return { ...acc, [match?.field as string]: tempArray }
        } else return acc
      }
      if (
        match?.map &&
        [
          'ESTATE_PROPERTY_EXTRAS',
          'ESTATE_PROPERTY_COMMERCIAL_EXTRAS',
          'ESTATE_PROPERTY_LAND_TYPE_EXTRAS',
        ].includes(group[0])
      ) {
        value = group[1].reduce((acc, property) => {
          let tempField
          const tempValue = get(property, 'valueText', '')

          if (tempValue && (match?.map as unknown as Map<string, string>)) {
            tempField = match?.map?.get(tempValue)
          }
          if (tempField) {
            return { ...acc, [tempField as string]: tempValue }
          } else return acc
        }, {})
        return { ...acc, extras: value }
      }
    }
    return acc
  }, {})
  const interest = calculateInterest(data?.adCategory?.id)
  const category = calculateCategory(data?.adCategory?.id)
  temp.parsedData = {
    category,
    interest,
    ...transformedProperties,
  }
  return temp
}
